import { render, staticRenderFns } from "./AddEditComments.vue?vue&type=template&id=fc26ce30&"
import script from "./AddEditComments.vue?vue&type=script&lang=ts&"
export * from "./AddEditComments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports